/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { AsyncResult, IActionContext } from '@msdyn365-commerce/core';

import { BaseCartState } from '../cart-state/base-cart-state';
import { ICartState } from '../state-interfaces/i-cart-state';
import cartStateDataAction from './cart-state-data-action';
import { GlobalStateInput } from './global-state-data-action';

export function getCartState(ctx: IActionContext): AsyncResult<ICartState> {
    return cartStateDataAction(
        new GlobalStateInput<ICartState>('CARTSTATE', BaseCartState, ctx.requestContext.apiSettings, ctx.requestContext),
        ctx
    );
}
